import { jsx as _jsx } from "react/jsx-runtime";
import './PeriodCard.css';
import { Period } from '../../model/Period';
import { Card } from 'antd';
import dayjs from 'dayjs';
const PeriodCard = (props) => {
    const renderPeriodLabel = (period) => {
        switch (period) {
            case Period.Month:
                return dayjs(new Date()).format('MMMM').toUpperCase();
            case Period.Today:
                return 'TODAY';
            case Period.Week:
                return 'THIS WEEK';
        }
    };
    return (_jsx(Card, { title: renderPeriodLabel(props.period), className: `period-card period-${props.period}`, size: "small", children: props.children }));
};
export default PeriodCard;
